module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Grid List Widget */

(function(fox, undefined) {

	fox.registerWidget('List', {
		init: function() {
			// this.setOption('$template', '@this:tpl.row');
			this.callParent('init', arguments);

			this.hookWrapper('initTpl');
			this.initCollection();
		},

		initTpl: function() {
			this.row = this.getTemplater(this.getOption('tpl.row'));
		},

		initCollection: function() {
			var source = this.getOption('collection') || [];
			var collectionApi;

			if (fox.isArray(source)) {
				this.collection = source;
			} else if (source) {
				if (fox.isString(source)) {
					collectionApi = this._wom.selectFirst(source, this);
				} else {
					collectionApi = source;
				}

				if (collectionApi) {
					collectionApi.send(collectionApi.getOption('params') || {});

					this.handleEvent(collectionApi, ['success'], fox.bind(function(data) {
						if (this.getOption('apiCustomVar')) {
							this.setCollection(fox.objectGet(data.answer, this.getOption('apiCustomVar')), this.getOption('autoRender'));
						} else {
							this.setCollection(data.answer.response, this.getOption('autoRender'));
						}
					}, this));
				}
			}
		},

		getCollection: function() {
			return this.collection;
		},

		setCollection: function(collection, render) {
			render = !render && true || render;

			this.collection = collection ;

			if (render) this.render();
			
			return this;
		},

		//Render collection
		rendering: function() {
			var emptyRow;
			var tplo = this.getTemplateOptions();

			if (this.getOption('tpl.emptyRow')) {
				emptyRow = this.getTemplater(this.getOption('tpl.emptyRow'));
			}

			if (fox.count(this.collection) === 0 && emptyRow) {
				this.fragment = emptyRow.setData(tplo).compile();
			} else if (this.row) {
				this.fragment = this.row.setData(this.collection)
					.compile(fox.isObject(this.collection) && {iterateScope: 'default'});
			}
		},

		running: function() {
			if (!this.getOption('externalLoad') && this.collectionApi) {
				this.collectionApi.send(this.collectionApi.getOption('params') || {});
			}
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/list/list.js
// module id = 206
// module chunks = 0